__webpack_require__.p = "https://assets-01.periodica.press/46777f7-20308767613/";